var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTyping = function SvgIconTyping(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.2422C11.6152 11.2422 12.114 10.7434 12.114 10.1282C12.114 9.51291 11.6152 9.01416 11 9.01416C10.3847 9.01416 9.88599 9.51291 9.88599 10.1282C9.88599 10.7434 10.3847 11.2422 11 11.2422Z",
    fill: "#F27C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0849 11.2422C15.7002 11.2422 16.1989 10.7434 16.1989 10.1282C16.1989 9.51291 15.7002 9.01416 15.0849 9.01416C14.4697 9.01416 13.9709 9.51291 13.9709 10.1282C13.9709 10.7434 14.4697 11.2422 15.0849 11.2422Z",
    fill: "#F27C25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91405 11.2422C7.52929 11.2422 8.02805 10.7434 8.02805 10.1282C8.02805 9.51291 7.52929 9.01416 6.91405 9.01416C6.2988 9.01416 5.80005 9.51291 5.80005 10.1282C5.80005 10.7434 6.2988 11.2422 6.91405 11.2422Z",
    fill: "#F27C25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.477 1 1 5.029 1 10C1.01575 11.293 1.32288 12.5659 1.89856 13.7238C2.47423 14.8817 3.30362 15.8949 4.325 16.688L3 20L8.334 18.666C9.20571 18.8857 10.101 18.9978 11 19C16.523 19 21 14.97 21 10C21 5.03 16.523 1 11 1ZM11 18C10.1825 17.9989 9.36815 17.8981 8.575 17.7L8.333 17.64L8.091 17.701L4.655 18.56L5.255 17.06L5.529 16.376L4.955 15.912C4.05159 15.2104 3.31711 14.315 2.8057 13.2918C2.29428 12.2686 2.01895 11.1437 2 10C2 5.589 6.037 2 11 2C15.963 2 20 5.589 20 10C20 14.411 15.962 18 11 18Z",
    fill: "#F27C25",
    stroke: "#F27C25",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTyping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_typing.f12f5896.svg";
export { ForwardRef as ReactComponent };